import UserService from '../services/user';
import ClientService from '../services/client';
import ProfileService from '../services/profile';
import AuthService from '../services/auth';
import StateService from "../services/state";
import CityService from "../services/city";
import AddressService from '../services/address';
import MenuService from '../services/menu'
import PetsService from '../services/pets';
import RacaService from "../services/raca";
import ClinicService from "../services/clinic";
import VacinaService from "../services/vacina";
import ExameService from "../services/exam";
import CategoryService from "../services/category";
import PostService from "../services/post";
import BathService from "../services/bath";
import WeightService from "../services/weight";
import ConsultationService from "../services/consultation";
import MedicineService from "../services/medicine";
import ViaADMService from "../services/via_adm";
import AcaoService from "../services/action";
import ReminderService from "../services/reminder";
import PolicyService from "../services/policy";
import GraphicService from '../services/graphic';
import CountryService from '../services/country';
import CarrierService from '../services/carrier';
import ManualService from '../services/manual';
import CenterService from '../services/center';
import PageService from '../services/page';
import DiscountService from '../services/discount';
import IntegratorService from '../services/integrator';

export default class Facade {
   userService = new UserService();
   clientService = new ClientService();
   stateService = new StateService();
   cityService = new CityService();
   profileService = new ProfileService();
   authService = new AuthService();
   addressService = new AddressService();
   menuService = new MenuService();
   petsService = new PetsService();
   racaService = new RacaService();
   clinicService = new ClinicService();
   vacinaService = new VacinaService();
   exameService = new ExameService();
   categoryService = new CategoryService();
   postService = new PostService();
   bathService = new BathService();
   weightService = new WeightService();
   consultationService = new ConsultationService();
   medicineService = new MedicineService();
   viaADMService = new ViaADMService();
   acaoService = new AcaoService();
   reminderService = new ReminderService();
   policyService = new PolicyService();
   graphicService = new GraphicService();
   countryService = new CountryService();
   carrierService = new CarrierService();
   manualService = new ManualService();
   centerService = new CenterService();
   pageService = new PageService();
   discountService = new DiscountService();
   integratorService = new IntegratorService();

   //AUTH
   login(user) {
      return this.authService.login(user);
   }

   forgotPassword(model) {
      return this.authService.forgotPassword(model);
   }

   firstAccess(user) {
      return this.authService.firstAccess(user);
   }

   logout() {
      this.authService.logout();
   }

   isLoggedIn() {
      return this.authService.isLoggedIn();
   }

   isAdmin() {
      return this.authService.isAdmin();
   }

   setUser(user) {
      this.authService.setUser(user);
   }

   getAuthUser() {
      return this.authService.getUser();
   }

   getUserDetail(user) {
      return this.authService.getUserDetail(user);
   }

   refreshToken() {
      return this.authService.refreshToken();
   }

   hasPermission(permission) {
      return this.authService.hasPermission(permission);
   }

   hasRole(roles) {
      return this.authService.hasRole(roles);
   }

   //USUARIO
   listUser(params) {
      return this.userService.list(params);
   }
   getUser(id) {
      return this.userService.get(id);
   }
   createUser(model) {
      return this.userService.create(model);
   }
   updateUser(model) {
      return this.userService.update(model);
   }
   deleteUser(id) {
      return this.userService.delete(id);
   }
   changePassword(model) {
      return this.userService.changePassword(model);
   }


   //CLIENTE
   searchClient(params) {
      return this.clientService.search(params);
   }
   listClient(params) {
      return this.clientService.list(params);
   }
   getClient(id) {
      return this.clientService.get(id);
   }
   createClient(model) {
      return this.clientService.create(model);
   }
   updateClient(model) {
      return this.clientService.update(model);
   }
   deleteClient(id) {
      return this.clientService.delete(id);
   }


   //PERFIL
   listProfile() {
      return this.profileService.list();
   }

   listState(params) {
      return this.stateService.list(params);
   }

   listCity(params) {
      return this.cityService.list(params);
   }

   searchCep(cep) {
      return this.addressService.searchCep(cep);
   }

   listMenu(params) {
      return this.menuService.list(params)
   }

   getMenu(id) {
      return this.menuService.get(id)
   }

   createMenu(params) {
      return this.menuService.create(params)
   }

   updateMenu(model) {
      return this.menuService.update(model)
   }

   sortMenu(id, model) {
      return this.menuService.sort(id, model)
   }

   deleteMenu(id) {
      return this.menuService.delete(id)
   }


   //Pets

   listPet(params, idCliente) {
      return this.petsService.list(params, idCliente);
   }
   getPet(id, idCliente) {
      return this.petsService.get(id, idCliente);
   }
   createPet(model, idCliente) {
      return this.petsService.create(model, idCliente);
   }
   updatePet(model, idCliente, id) {
      return this.petsService.update(model, idCliente, id);
   }
   deletePet(id, idCliente) {
      return this.petsService.delete(id, idCliente);
   }

   //Raça
   listRacas(params) {
      return this.racaService.list(params);
   }

   //Clinics

   listClinic(params) {
      return this.clinicService.list(params);
   }
   getClinic(id, ) {
      return this.clinicService.get(id);
   }
   createClinic(model) {
      return this.clinicService.create(model);
   }
   updateClinic(model, id) {
      return this.clinicService.update(model, id);
   }
   deleteClinic(id) {
      return this.clinicService.delete(id);
   }
   importClinic(model) {
      return this.clinicService.import(model);
   }

   // VACINAS
   createVaccine(model, idPet) {
      return this.vacinaService.create(model, idPet);
   }
   getVaccine(id) {
      return this.vacinaService.get(id);
   }
   listVaccines(params) {
      return this.vacinaService.list(params);
   }
   updateVaccine(id) {
      return this.vacinaService.update(id);
   }
   deleteVaccine(id) {
      return this.vacinaService.delete(id);
   }

   // EXAMES
   createExam(model) {
      return this.exameService.create(model);
   }
   getExam(id) {
      return this.exameService.get(id);
   }
   listExam(params) {
      return this.exameService.list(params);
   }
   updateExam(model, id) {
      return this.exameService.update(model, id);
   }
   deleteExam(id) {
      return this.exameService.delete(id);
   }

   //Categorias
   listCategory(params) {
      return this.categoryService.list(params);
   }
   getCategory(id, idCliente) {
      return this.categoryService.get(id, idCliente);
   }
   createCategory(model) {
      return this.categoryService.create(model);
   }
   updateCategory(model, id) {
      return this.categoryService.update(model, id);
   }
   deleteCategory(id, idCliente) {
      return this.categoryService.delete(id, idCliente);
   }

   //POST
   listPost(params) {
      return this.postService.list(params);
   }
   getPost(id) {
      return this.postService.get(id);
   }
   createPost(model) {
      return this.postService.create(model);
   }
   createPostImage(model) {
      return this.postService.saveImage(model);
   }
   updatePost(model, id) {
      return this.postService.update(model, id);
   }
   deletePost(id) {
      return this.postService.delete(id);
   }

   // BANHO
   createBath(model) {
      return this.bathService.create(model);
   }
   getBath(id) {
      return this.bathService.get(id);
   }
   listBath(params) {
      return this.bathService.list(params);
   }

   updateBath(model, id) {
      return this.bathService.update(model, id);
   }
   deleteBath(id) {
      return this.bathService.delete(id);
   }


   // Peso
   createWeight(model) {
      return this.weightService.create(model);
   }
   getWeight(id) {
      return this.weightService.get(id);
   }
   listWeight(params) {
      return this.weightService.list(params);
   }

   updateWeight(model, id) {
      return this.weightService.update(model, id);
   }
   deleteWeight(id) {
      return this.weightService.delete(id);
   }


   //CONSULTA Query
   createConsultation(model) {
      return this.consultationService.create(model);
   }
   getConsultation(id) {
      return this.consultationService.get(id);
   }
   listConsultation(params) {
      return this.consultationService.list(params);
   }

   updateConsultation(model, id) {
      return this.consultationService.update(model, id);
   }
   deleteConsultation(id) {
      return this.consultationService.delete(id);
   }
   //MEDICAMENTOS
   createMedicine(model) {
      return this.medicineService.create(model);
   }
   getMedicine(id) {
      return this.medicineService.get(id);
   }
   listMedicine(params) {
      return this.medicineService.list(params);
   }

   updateMedicine(model, id) {
      return this.medicineService.update(model, id);
   }
   deleteMedicine(id) {
      return this.medicineService.delete(id);
   }


   //via Administracao
   listViaADM(params) {
      return this.viaADMService.list(params);
   }

   listAcao(params) {
      return this.acaoService.list(params);
   }

   listReminder(params) {
      return this.reminderService.list(params);
   }
   deleteReminder(id) {
      return this.reminderService.delete(id);
   }
   createReminder(reminder) {
      return this.reminderService.create(reminder);
   }

   //Apólices
   listPolicies(params) {
      return this.policyService.list(params);
   }
   listPoliciesClient(params) {
      return this.policyService.listPoliciesClient(params);
   }
   getPolicy(id) {
      return this.policyService.get(id);
   }

   //search Data
   searchData(params) {
      return this.graphicService.get(params)
   }

   //Países
   listCountry(params) {
      return this.countryService.list(params);
   }
   getCountry(id, idCliente) {
      return this.countryService.get(id, idCliente);
   }
   createCountry(model) {
      return this.countryService.create(model);
   }
   updateCountry(model, id) {
      return this.countryService.update(model, id);
   }
   deleteCountry(id, idCliente) {
      return this.countryService.delete(id, idCliente);
   }

   //Operadoras
   listCarrier(params) {
      return this.carrierService.list(params);
   }
   getCarrier(id, idCliente) {
      return this.carrierService.get(id, idCliente);
   }
   createCarrier(model) {
      return this.carrierService.create(model);
   }
   updateCarrier(model, id) {
      return this.carrierService.update(model, id);
   }
   deleteCarrier(id, idCliente) {
      return this.carrierService.delete(id, idCliente);
   }

   //Manuais Usuário
   listManual(params) {
      return this.manualService.list(params);
   }
   getManual(id, idCliente) {
      return this.manualService.get(id, idCliente);
   }
   createManual(model) {
      return this.manualService.create(model);
   }
   updateManual(model, id) {
      return this.manualService.update(model, id);
   }
   deleteManual(id) {
      return this.manualService.delete(id);
   }

   //Central Atendimento
   listCenter(params) {
      return this.centerService.list(params);
   }
   getCenter(id) {
      return this.centerService.get(id);
   }
   createCenter(model) {
      return this.centerService.create(model);
   }
   updateCenter(model, id) {
      return this.centerService.update(model, id);
   }
   deleteCenter(id) {
      return this.centerService.delete(id);
   }

   //Páginas
   listPage(params) {
      return this.pageService.list(params);
   }
   getPage(id) {
      return this.pageService.get(id);
   }
   createPage(model) {
      return this.pageService.create(model);
   }
   updatePage(model, id) {
      return this.pageService.update(model, id);
   }
   deletePage(id) {
      return this.pageService.delete(id);
   }

   //Cupom desconto
   listDiscount(params) {
      return this.discountService.list(params);
   }
   getDiscount(id) {
      return this.discountService.get(id);
   }
   createDiscount(model) {
      return this.discountService.create(model);
   }
   updateDiscount(model, id) {
      return this.discountService.update(model, id);
   }
   deleteDiscount(id) {
      return this.discountService.delete(id);
   }
   importDiscount(model) {
      return this.discountService.import(model);
   }

   //Integradora
   listIntegrator(params) {
      return this.integratorService.list(params);
   }
   getIntegrator(id) {
      return this.integratorService.get(id);
   }
   createIntegrator(model) {
      return this.integratorService.create(model);
   }
   updateIntegrator(model, id) {
      return this.integratorService.update(model, id);
   }
   deleteIntegrator(id) {
      return this.integratorService.delete(id);
   }
}



// WEBPACK FOOTER //
// ./src/facade/facade.js